import classNames from 'classnames';
import React, { forwardRef } from 'react';
import css from './MediaRowBase.module.scss';

interface MediaRowBaseProps {
  children?: React.ReactNode;
  className?: string;
  variant?: 'header' | 'item';
  tableTheme?: 'default' | 'invoice';
  showCheckbox?: boolean;
  checkboxContent?: React.ReactNode;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  onClick?: () => void;
  role?: string;
  tabIndex?: number;
  onKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  style?: React.CSSProperties;
}

export const MediaRowBase = forwardRef<HTMLDivElement, MediaRowBaseProps>(
  (
    {
      children,
      className,
      variant = 'item',
      tableTheme = 'default',
      showCheckbox = true,
      checkboxContent,
      leftContent,
      rightContent,
      onClick,
      role,
      tabIndex,
      onKeyDown,
      style,
    },
    ref,
  ) => {
    const containerClass = classNames(
      css.rowContainer,
      {
        [css.headerContainer]: variant === 'header',
        [css.itemContainer]: variant === 'item',
        [css.headerInvoiceTheme]: variant === 'header' && tableTheme === 'invoice',
        [css.itemInvoiceTheme]: variant === 'item' && tableTheme === 'invoice',
      },
      className,
    );

    const contentLeftClass = classNames(css.contentLeft, {
      [css.headerContentLeft]: variant === 'header',
      [css.itemContentLeft]: variant === 'item',
    });

    const contentRightClass = classNames(css.contentRight, {
      [css.headerContentRight]: variant === 'header',
      [css.itemContentRight]: variant === 'item',
    });

    const checkboxContainerClass = classNames(css.checkboxContainer, {
      [css.headerCheckboxContainer]: variant === 'header',
      [css.itemCheckboxContainer]: variant === 'item',
    });

    return (
      <div
        ref={ref}
        className={containerClass}
        onClick={onClick}
        role={role}
        tabIndex={tabIndex}
        onKeyDown={onKeyDown}
        style={style}
      >
        <div className={contentLeftClass}>
          {showCheckbox && checkboxContent && (
            <div className={checkboxContainerClass}>{checkboxContent}</div>
          )}
          {leftContent}
        </div>
        <div className={contentRightClass}>{rightContent}</div>
        {children}
      </div>
    );
  },
);

MediaRowBase.displayName = 'MediaRowBase';
